var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 24,
    viewBox: "0 0 22 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.0917 4.79418L19.1027 21.1153C19.0045 22.7361 17.6616 23.9998 16.0385 23.9998H5.72858C4.10551 23.9998 2.76263 22.7361 2.6644 21.1153L1.67537 4.79418C1.66198 4.56423 1.74347 4.33874 1.90198 4.17018C2.06049 4.00162 2.2804 3.90674 2.51147 3.90674H19.2557C19.4867 3.90674 19.7066 4.00162 19.8651 4.17018C20.0237 4.33874 20.1051 4.56423 20.0917 4.79418ZM18.366 5.58116H3.40114L4.33658 21.0148C4.38124 21.7505 4.99072 22.3253 5.72858 22.3253H16.0385C16.7764 22.3253 17.3859 21.7505 17.4305 21.0148L18.366 5.58116Z",
    fill: "#5D616C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.9302 3.90674C21.3924 3.90674 21.7674 4.28181 21.7674 4.74395C21.7674 5.20609 21.3924 5.58116 20.9302 5.58116H0.837209C0.37507 5.58116 0 5.20609 0 4.74395C0 4.28181 0.37507 3.90674 0.837209 3.90674H20.9302Z",
    fill: "#5D616C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0588 2.22698L16.7118 4.51423C16.7844 4.76651 16.733 5.03888 16.5756 5.24874C16.4171 5.4586 16.1693 5.5814 15.907 5.5814H5.86048C5.59816 5.5814 5.35034 5.4586 5.19183 5.24874C5.03444 5.03888 4.98309 4.76651 5.05565 4.51423L5.70867 2.22698C6.08597 0.908651 7.29044 0 8.66123 0H13.1063C14.477 0 15.6815 0.908651 16.0588 2.22698ZM14.448 2.68688C14.2772 2.08744 13.7303 1.67442 13.1063 1.67442H8.66123C8.03723 1.67442 7.49025 2.08744 7.31946 2.68688L6.97006 3.90698H14.7974L14.448 2.68688Z",
    fill: "#5D616C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0465 9.76739C10.0465 9.30525 10.4216 8.93018 10.8837 8.93018C11.3459 8.93018 11.7209 9.30525 11.7209 9.76739V17.5813C11.7209 18.0435 11.3459 18.4185 10.8837 18.4185C10.4216 18.4185 10.0465 18.0435 10.0465 17.5813V9.76739Z",
    fill: "#5D616C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.6234 17.6473C15.5776 18.1072 15.1669 18.4432 14.7069 18.3974C14.247 18.3516 13.9122 17.9408 13.9579 17.4809L14.736 9.70158C14.7817 9.24167 15.1925 8.90567 15.6524 8.95144C16.1123 8.99721 16.4483 9.408 16.4026 9.8679L15.6234 17.6473Z",
    fill: "#5D616C"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.80954 17.4809C7.85531 17.9408 7.52042 18.3516 7.06052 18.3974C6.60061 18.4432 6.18982 18.1072 6.14405 17.6473L5.36489 9.8679C5.31912 9.408 5.65512 8.99721 6.11503 8.95144C6.57494 8.90567 6.98573 9.24167 7.03149 9.70158L7.80954 17.4809Z",
    fill: "#5D616C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.3698a9371705d58c74521a26c227b9e4.svg";
export { ForwardRef as ReactComponent };